import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
import { Paper, Stack } from '@mui/material'
import { SPACING } from '@common/theme/spacing'

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  borderRadius: 2,
  bgcolor: 'background.default',
  boxShadow: 8,
  width: 538,
}

export default function UnavailableReassignementModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Modal open={open}>
      <Paper sx={modalStyle}>
        <Stack padding={SPACING.spacingXxl} paddingBottom={0}>
          <Typography variant="h6" color="text.primary">
            Exam reassignment is unavailable because a read task has already been created
          </Typography>
          <Typography variant="body1" color="text.primary">
            Please, contact an IAM to proceed with the reassignment.
          </Typography>
        </Stack>
        <Stack padding={SPACING.spacingXxl} alignSelf={'stretch'} alignItems={'flex-end'}>
          <Button
            variant="contained"
            sx={{
              bgcolor: 'secondary.main',
              color: 'secondary.contrastText',
            }}
            onClick={onClose}
            data-testid="close-comment-task-button"
          >
            Close
          </Button>
        </Stack>
      </Paper>
    </Modal>
  )
}
